import { Notification, NotificationType } from "@scrile/api-provider/dist/api/NotificationsProvider";

export { default } from "./NotificationLimitedCreatorApplicationDeclined.vue";

export const selector = (item: Notification): boolean => {
  return item.type === NotificationType.LIMITED_CREATOR_APPLICATION_DECLINED;
};
